var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "timesheet layout" },
    [
      _c("positions-modal", {
        ref: "positionsModal",
        attrs: { positions: _vm.positions },
        on: { apply: _vm.updatePositions },
      }),
      _c("workers-modal", {
        ref: "workersModal",
        attrs: { positions: _vm.positions },
        on: { apply: _vm.addWorkers },
      }),
      _c("columns-modal", {
        ref: "columnsModal",
        attrs: {
          columns: _vm.columnsList,
          "default-selected": _vm.defaultColumns,
          "blocked-columns": ["worker", "days"],
          "columns-count": 2,
        },
        on: { apply: _vm.saveUserColumns },
      }),
      _c("remove-timesheet-modal", {
        ref: "removeTimesheetModal",
        on: { remove: _vm.onRemove },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c(
          "div",
          { staticClass: "layout-title" },
          [
            _vm.currentTimesheet
              ? [
                  _c("b", [_vm._v("Табель")]),
                  _vm._v(" " + _vm._s(_vm.timesheetName) + " "),
                ]
              : [_c("b", [_vm._v("Новый табель")])],
          ],
          2
        ),
        _c("div", { staticClass: "layout-header-actions" }, [
          _vm.currentTimesheet && _vm.currentTimesheet.id
            ? _c(
                "div",
                { staticClass: "layout-header-action" },
                [
                  _c("c-button-dropdown", {
                    staticClass: "actions",
                    attrs: {
                      icon: "arrow",
                      type: "dropdown",
                      label: "Действия",
                      dropdown: {
                        position: "left",
                        items: _vm.buttonDropdownItems,
                      },
                    },
                    on: { remove: _vm.removeTimesheet },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button2", {
                attrs: {
                  responsive: true,
                  size: "small",
                  label: "К списку табелей",
                  icon: "back",
                },
                on: { click: _vm.toList },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "timesheet__content" },
        [
          _vm.timesheetDataLoading
            ? [
                _c("Loader", {
                  attrs: {
                    active: true,
                    label: "Данные загружаются",
                    height: 434,
                  },
                }),
              ]
            : [
                _vm.canEdit
                  ? _c("timesheet-filters", {
                      staticClass: "timesheet-filters",
                      attrs: {
                        "server-error": _vm.serverError,
                        filters: _vm.filters,
                        submitted: _vm.submitted,
                      },
                      on: { reset: _vm.resetFilters, apply: _vm.applyFilters },
                    })
                  : _vm._e(),
                _vm.inited
                  ? _c(
                      "div",
                      { staticClass: "timesheet-chart" },
                      [
                        _c("div", { staticClass: "timesheet-chart__actions" }, [
                          _c(
                            "div",
                            { staticClass: "timesheet-chart__actions-group" },
                            [
                              _vm.positions.length
                                ? _c("c-button2", {
                                    staticClass:
                                      "timesheet-chart__action timesheet-chart__add-workers",
                                    attrs: {
                                      size: "small",
                                      label: "Добавить сотрудников",
                                      disabled: _vm.loading,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openWorkersModal()
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _c("codes-dictionary", {
                                staticClass:
                                  "timesheet-chart__action timesheet-chart__config-codes",
                                attrs: { disabled: _vm.loading },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "timesheet-chart__actions-group" },
                            [
                              _c("c-switcher2", {
                                staticClass:
                                  "h-switcher timesheet-chart__action timesheet-chart__shifts",
                                attrs: {
                                  type: "group",
                                  items: [
                                    { label: "Все смены", value: "all" },
                                    { label: "Дневная", value: "day" },
                                    { label: "Ночная", value: "night" },
                                  ],
                                  disabled: _vm.loading,
                                },
                                model: {
                                  value: _vm.shift,
                                  callback: function ($$v) {
                                    _vm.shift = $$v
                                  },
                                  expression: "shift",
                                },
                              }),
                              _c("c-button2", {
                                staticClass:
                                  "timesheet-chart__action timesheet-chart__config-positions",
                                attrs: {
                                  size: "small",
                                  label: "Должности",
                                  disabled: _vm.loading,
                                },
                                on: { click: _vm.openPositionsModal },
                              }),
                              _c("c-button2", {
                                staticClass:
                                  "timesheet-chart__action timesheet-chart__config-columns",
                                attrs: {
                                  size: "small",
                                  label: "Настроить столбцы",
                                  icon: "cog",
                                  disabled: _vm.loading,
                                },
                                on: { click: _vm.configColumns },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm.loading
                          ? _c("Loader", {
                              attrs: {
                                active: _vm.loading,
                                label: "Производится расчет",
                                height: 434,
                              },
                            })
                          : _vm._e(),
                        !_vm.loading
                          ? [
                              _c(
                                "scrolled-table",
                                {
                                  staticClass: "timesheet-chart__table",
                                  attrs: {
                                    "fix-first": true,
                                    "fix-last": true,
                                  },
                                },
                                [
                                  _c(
                                    "table",
                                    { staticClass: "h-table" },
                                    [
                                      _c("thead", [
                                        _c(
                                          "tr",
                                          _vm._l(
                                            _vm.columns,
                                            function (column) {
                                              return _c(
                                                "th",
                                                {
                                                  key: column.id,
                                                  staticClass:
                                                    "timesheet-chart-column",
                                                  class:
                                                    "timesheet-chart-column__" +
                                                    column.id,
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "h-table__header",
                                                    },
                                                    [
                                                      column.id === "days"
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "h-table__col-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.monthName
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "timeline",
                                                              },
                                                              _vm._l(
                                                                _vm.chartData
                                                                  .total.days,
                                                                function (day) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: day.key,
                                                                      staticClass:
                                                                        "day",
                                                                      class: {
                                                                        conflict:
                                                                          day.hasConflict,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            day.day
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        : [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "h-table__col-title",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          [
                                                                            column.shortName,
                                                                            column.unit ===
                                                                              "ruble" &&
                                                                              "฿",
                                                                            column.unit ===
                                                                              "ruble/unit" &&
                                                                              "฿/шт.",
                                                                            column.unit ===
                                                                              "HH:MM" &&
                                                                              "чч:мм",
                                                                          ]
                                                                            .filter(
                                                                              Boolean
                                                                            )
                                                                            .join(
                                                                              ", "
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            column.id !== "name"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "h-table__actions",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "c-button",
                                                                      {
                                                                        attrs: {
                                                                          id: `table-column-button-description-${column.id}`,
                                                                          size: "small",
                                                                          icon: "info",
                                                                          "no-border":
                                                                            "",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "b-popover",
                                                                      {
                                                                        attrs: {
                                                                          placement:
                                                                            "top",
                                                                          triggers:
                                                                            "hover",
                                                                          target: `table-column-button-description-${column.id}`,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              column.name
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                      _vm._l(
                                        _vm.positionsList,
                                        function (position) {
                                          return [
                                            _c(
                                              "tr",
                                              {
                                                key: position.code,
                                                staticClass: "position-name",
                                              },
                                              [
                                                _vm._l(
                                                  _vm.columns,
                                                  function (column) {
                                                    return [
                                                      _c(
                                                        "td",
                                                        {
                                                          key: column.id,
                                                          class:
                                                            "position-name__" +
                                                            column.id,
                                                        },
                                                        [
                                                          _c(
                                                            "table-position-cell",
                                                            {
                                                              attrs: {
                                                                column:
                                                                  column.id,
                                                                position:
                                                                  position,
                                                                data:
                                                                  _vm.chartData
                                                                    .positions[
                                                                    position
                                                                      .code
                                                                  ] || {},
                                                              },
                                                              on: {
                                                                addWorkers:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.addWorkersToPosition(
                                                                      position
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "transition",
                                              {
                                                key: position.code + "-workers",
                                                attrs: { name: "slide" },
                                              },
                                              [
                                                _c(
                                                  "tbody",
                                                  {
                                                    key:
                                                      position.code +
                                                      "-workers",
                                                    staticClass:
                                                      "position-workers",
                                                  },
                                                  [
                                                    _vm._l(
                                                      (
                                                        _vm.chartData.positions[
                                                          position.code
                                                        ] || []
                                                      ).workers,
                                                      function (worker) {
                                                        return [
                                                          _vm.shiftDayOrNight(
                                                            worker
                                                          )
                                                            ? _c(
                                                                "tr",
                                                                {
                                                                  key: worker.id,
                                                                  staticClass:
                                                                    "worker-data",
                                                                },
                                                                _vm._l(
                                                                  _vm.columns,
                                                                  function (
                                                                    column
                                                                  ) {
                                                                    return _c(
                                                                      "td",
                                                                      {
                                                                        key: column.id,
                                                                        class:
                                                                          "worker-data__" +
                                                                          column.id,
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "table-cell",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                column:
                                                                                  column.id,
                                                                                worker:
                                                                                  worker,
                                                                                position:
                                                                                  position,
                                                                                filial:
                                                                                  _vm.currentTimesheet &&
                                                                                  _vm
                                                                                    .currentTimesheet
                                                                                    .filial
                                                                                    .id,
                                                                              },
                                                                            on: {
                                                                              onDayClick:
                                                                                _vm.onDayClick,
                                                                              remove:
                                                                                _vm.removeWorker,
                                                                            },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                          ]
                                        }
                                      ),
                                      _c("tfoot", [
                                        _c(
                                          "tr",
                                          _vm._l(
                                            _vm.columns,
                                            function (column) {
                                              return _c(
                                                "td",
                                                {
                                                  key: column.id,
                                                  staticClass:
                                                    "timesheet-total-column",
                                                  class:
                                                    "timesheet-total-column__" +
                                                    column.id,
                                                },
                                                [
                                                  _c("table-total-cell", {
                                                    attrs: {
                                                      column: column.id,
                                                      workers: _vm.workersList,
                                                      stats:
                                                        _vm.chartData.total,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _vm.canEdit
                                ? _c(
                                    "div",
                                    { staticClass: "timesheet__actions" },
                                    [
                                      _c("c-button2", {
                                        staticClass: "timesheet__reset",
                                        attrs: {
                                          label: "Отменить",
                                          size: "large",
                                        },
                                        on: { click: _vm.reset },
                                      }),
                                      _c("c-button2", {
                                        staticClass: "timesheet__save",
                                        attrs: {
                                          label: "Сохранить",
                                          disabled: _vm.saving,
                                          color: "primary",
                                          size: "large",
                                        },
                                        on: { click: _vm.save },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm.feedback
        ? _c(
            "div",
            { staticClass: "timesheet-feedback", class: _vm.feedback.status },
            [
              _c("div", { staticClass: "timesheet-feedback__wrapper" }, [
                _c(
                  "div",
                  { staticClass: "timesheet-feedback__icon" },
                  [
                    _vm.feedback.status === "success"
                      ? [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "14",
                                height: "10",
                                viewBox: "0 0 14 10",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                                  fill: "#12C971",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                                  fill: "#12C971",
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm.feedback.status === "error"
                      ? [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "10",
                                  cy: "10",
                                  r: "9",
                                  stroke: "#FF238D",
                                  "stroke-width": "2",
                                },
                              }),
                              _c("circle", {
                                attrs: {
                                  cx: "10",
                                  cy: "14",
                                  r: "1",
                                  fill: "#FF238D",
                                },
                              }),
                              _c("rect", {
                                attrs: {
                                  x: "9",
                                  y: "5",
                                  width: "2",
                                  height: "6",
                                  rx: "1",
                                  fill: "#FF238D",
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" " + _vm._s(_vm.feedback.text) + " "),
              ]),
            ]
          )
        : _vm._e(),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }